/**
 *  Returns client name as combined string; used in FormClient.js
 */
const makeName = (achternaam: string, voorletters: string, tussenvoegsel: string, roepnaam: string) => {
	return achternaam + ', ' + voorletters + (tussenvoegsel === null ? ' ' : ' ' + tussenvoegsel) + (roepnaam === null ? '' : ' (' + roepnaam + ')');
};

export default makeName;
